<template>
    <div>
        <div class="pingList">
            <ul>
                <li v-for="(thisUserSessionsData) in $store.state.socket.connectedUsers" :key="thisUserSessionsData.user_id">
                    <span class="pingList__user">UserID: {{thisUserSessionsData.user_id}} | {{thisUserSessionsData.sessions_count}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>